export enum PaymentMethods {
  card = 'CC',
  paypal = 'PayPal',
  applePay = 'ApplePay',
  googlePay = 'GooglePay',
}

export const RELEASE_VERSION = '1.2';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      paymentMethods: PaymentMethods,
      releaseVersion: RELEASE_VERSION,
    },
  };
});
